/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import axiosInstance from '../functions/AxiosInstance'; // Asegúrate de que la ruta sea correcta

// Función para suscribirse a la newsletter
const subscribeNewsletter = async (newsletterData: { name: string; email: string }) => {
  const response = await axiosInstance.post('/newsletters/subscribe', newsletterData);
  return response.data; // Devuelve los datos de la respuesta
};

// Hook para suscribirse a la newsletter
export const useSubscribeNewsletter = () => {
  const mutation = useMutation({
    mutationFn: subscribeNewsletter, // Función para suscribirse
    onSuccess: () => {
      toast.success("Te has suscrito al boletín con éxito.");
    },
    onError: (error: any) => {
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Error desconocido";

      toast.error(errorMessage); // Mostrar solo el mensaje del backend
      console.error("Error al suscribirse al boletín:", errorMessage);
    },
  });

  return {
    ...mutation,
    isLoading: mutation.isPending, // Estado de carga de la mutación
    isSuccess: mutation.isSuccess, // Indica si la suscripción fue exitosa
  };
};



// Función para obtener las suscripciones a newsletters
const fetchSubscriptions = async () => {
  const response = await axiosInstance.get('/newsletters/my-subscriptions');
  return response.data; // Devuelve los datos de la respuesta
};

// Hook para listar las suscripciones a newsletters
export const useGetSubscriptions = () => {
  const { data, error, isLoading, isError } = useQuery({
    queryKey: ['my-subscriptions'], // Esto es lo que identifica la consulta en React Query
    queryFn: async () => {
      try {
        return await fetchSubscriptions();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        toast.error(`Error al obtener las suscripciones: ${error.response?.data?.message || 'Error desconocido'}`);
        console.error('Error al obtener las suscripciones:', error);
        throw error;
      }
    },
    refetchOnWindowFocus: false, // Opcional: Evita que los datos se vuelvan a obtener cuando el foco de la ventana cambia
  });

  return {
    subscriptions: data,    // Suscripciones obtenidas
    isLoading,              // Si está cargando
    isError,                // Si hubo un error
    error,                  // El error completo (si existe)
  };
};



// Función para obtener todas las suscripciones a newsletters
const fetchAllSubscriptions = async () => {
  const response = await axiosInstance.get('/newsletters/all');
  return response.data; // Devuelve los datos de la respuesta
};

// Hook para listar todas las suscripciones a newsletters
export const useGetAllSubscriptions = () => {
  const { data, error, isLoading, isError } = useQuery({
    queryKey: ['all-subscriptions'], // Esto es lo que identifica la consulta en React Query
    queryFn: async () => {
      try {
        return await fetchAllSubscriptions();
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        toast.error(`Error al obtener todas las suscripciones: ${error.response?.data?.message || 'Error desconocido'}`);
        console.error('Error al obtener todas las suscripciones:', error);
        throw error;
      }
    },
    refetchOnWindowFocus: false, // Opcional: Evita que los datos se vuelvan a obtener cuando el foco de la ventana cambia
  });

  return {
    subscriptions: data,    // Suscripciones obtenidas
    isLoading,              // Si está cargando
    isError,                // Si hubo un error
    error,                  // El error completo (si existe)
  };
};



// Función para eliminar una suscripción a newsletter
const deleteSubscription = async (id: string) => {
  const response = await axiosInstance.delete(`/newsletters/delete/${id}`);
  return response.data; // Devuelve los datos de la respuesta
};

// Hook para eliminar una suscripción a newsletter
export const useDeleteSubscription = () => {
  const mutation = useMutation({
    mutationFn: deleteSubscription, // Función que elimina la suscripción
    onSuccess: () => {
      toast.success('Suscripción eliminada con éxito.');
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.message || 'Error desconocido';
      toast.error(`Error al eliminar la suscripción: ${errorMessage}`);
      console.error('Error al eliminar la suscripción:', errorMessage);
    },
  });

  return {
    ...mutation,
    isLoading: mutation.isPending, // Estado de carga de la mutación
    isSuccess: mutation.isSuccess, // Indica si la eliminación fue exitosa
  };
};
